import React, { useMemo } from "react";
import { Select } from "antd";
// GENERATED ENUMS
import { Control } from "../../../flatbuffers/generated/control/control";
import { ControllerInfoContent } from "../../../flatbuffers/generated/controller-info/controller-info-content";
import { Fault } from "../../../flatbuffers/generated/fault/fault";
import { GroupControl } from "../../../flatbuffers/generated/group-control/group-control";
import { GroupSupervisoryStatus } from "../../../flatbuffers/generated/group-supervisory-status/group-supervisory-status";
import { EncodedMessageContent } from "../../../flatbuffers/generated/ln2/encoded-message-content";
import { MessageContent } from "../../../flatbuffers/generated/ln2/message-content";
import { Service } from "../../../flatbuffers/generated/service/service";
import { Status } from "../../../flatbuffers/generated/status/status";
import { Traffic } from "../../../flatbuffers/generated/traffic/traffic";
import { Usage } from "../../../flatbuffers/generated/usage/usage";
// INTERFACES
import { FbMessageRef } from "../../../interfaces/FbMessage.interface";
import { LiftType } from "../../../flatbuffers/generated/archive/lift-type";

interface Props {
  value: FbMessageRef | null;
  onChange: (ref: FbMessageRef | null) => void;
  deviceType?: LiftType | "BOTH";
  categoryFilter?: number[]; // MessageContent discriminant values to include; if empty, show all
  messageValueFilter?: Set<string>; // "messageContent:messageValue" keys; if set, only these options shown
  disabled?: boolean;
  placeholder?: string;
  allowClear?: boolean;
}

interface GroupedOptions {
  label: string;
  options: FbMessageRef[];
}

function enumToOptions(
  enumObj: Record<string, string | number>,
  prefix: string,
  encodedType: EncodedMessageContent,
  messageContent: MessageContent,
  deviceType: LiftType,
): FbMessageRef[] {
  return Object.entries(enumObj)
    .filter(([, v]) => typeof v === "number")
    .map(([key, v]) => ({
      encodedType,
      messageContent,
      messageValue: v as number,
      deviceType,
      label: `${prefix}::${key}`,
    }));
}

const optionKey = (o: FbMessageRef): string =>
  `${o.encodedType}:${o.messageContent}:${o.messageValue}:${o.deviceType}`;

// Category definitions — built once at module load
const ALL_CATEGORIES: Array<{
  label: string;
  messageContent: MessageContent;
  options: FbMessageRef[];
}> = [
  {
    label: "Status",
    messageContent: MessageContent.Status_StatusMessage,
    options: enumToOptions(
      Status as unknown as Record<string, string | number>,
      "Status",
      EncodedMessageContent.BitMaskMessage,
      MessageContent.Status_StatusMessage,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "Traffic",
    messageContent: MessageContent.Traffic_TrafficMessage,
    options: enumToOptions(
      Traffic as unknown as Record<string, string | number>,
      "Traffic",
      EncodedMessageContent.BitMaskMessage,
      MessageContent.Traffic_TrafficMessage,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "Usage",
    messageContent: MessageContent.Usage_UsageMessage,
    options: enumToOptions(
      Usage as unknown as Record<string, string | number>,
      "Usage",
      EncodedMessageContent.OneHotMessage,
      MessageContent.Usage_UsageMessage,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "Service",
    messageContent: MessageContent.Service_ServiceMessage,
    options: enumToOptions(
      Service as unknown as Record<string, string | number>,
      "Service",
      EncodedMessageContent.OneHotMessage,
      MessageContent.Service_ServiceMessage,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "Control",
    messageContent: MessageContent.Control_ControlMessage,
    options: enumToOptions(
      Control as unknown as Record<string, string | number>,
      "Control",
      EncodedMessageContent.BitMaskMessage,
      MessageContent.Control_ControlMessage,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "Fault",
    messageContent: MessageContent.Fault_FaultMessage,
    options: enumToOptions(
      Fault as unknown as Record<string, string | number>,
      "Fault",
      EncodedMessageContent.BitMaskMessage,
      MessageContent.Fault_FaultMessage,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "GroupSupervisoryStatus",
    messageContent: MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage,
    options: enumToOptions(
      GroupSupervisoryStatus as unknown as Record<string, string | number>,
      "GroupSupervisoryStatus",
      EncodedMessageContent.BitMaskMessage,
      MessageContent.GroupSupervisoryStatus_GroupSupervisoryStatusMessage,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "GroupControl",
    messageContent: MessageContent.GroupControl_GroupControlMessage,
    options: enumToOptions(
      GroupControl as unknown as Record<string, string | number>,
      "GroupControl",
      EncodedMessageContent.BitMaskMessage,
      MessageContent.GroupControl_GroupControlMessage,
      LiftType.ELEVATOR,
    ),
  },
  {
    label: "ControllerInfo",
    messageContent: MessageContent.ControllerInfo_ControllerInfoMessage,
    options: enumToOptions(
      ControllerInfoContent as unknown as Record<string, string | number>,
      "ControllerInfo",
      EncodedMessageContent.BitMaskMessage,
      MessageContent.ControllerInfo_ControllerInfoMessage,
      LiftType.ELEVATOR,
    ),
  },
];

export default function FlatbufferMessagePicker({
  value,
  onChange,
  deviceType = "BOTH",
  categoryFilter = undefined,
  messageValueFilter = undefined,
  disabled = undefined,
  placeholder = undefined,
  allowClear = undefined,
}: Props) {
  const groupedOptions = useMemo<GroupedOptions[]>(
    () =>
      ALL_CATEGORIES.filter((cat) => {
        // Apply categoryFilter if provided and non-empty
        if (categoryFilter && categoryFilter.length > 0) {
          if (!categoryFilter.includes(cat.messageContent)) return false;
        }
        return true;
      })
        .map((cat) => {
          // Filter options by messageValueFilter (per-message) and deviceType
          const filtered = cat.options.filter((o) => {
            if (
              messageValueFilter &&
              messageValueFilter.size > 0 &&
              !messageValueFilter.has(`${o.messageContent}:${o.messageValue}`)
            )
              return false;
            if (deviceType !== "BOTH" && o.deviceType !== deviceType) return false;
            return true;
          });
          return { label: cat.label, options: filtered };
        })
        .filter((g) => g.options.length > 0),
    [deviceType, categoryFilter, messageValueFilter],
  );

  const allOptions = useMemo(() => groupedOptions.flatMap((g) => g.options), [groupedOptions]);

  // A reference rebuilt from stored scalars — a saved modifier's step, say —
  // names its leaf but not necessarily the encoding this picker files the leaf
  // under (Usage and Service options are OneHot), and a value that matches no
  // option shows as its raw key. So the selection is resolved by leaf: the
  // option with the same content and value, when the picker offers one.
  const selected = value
    ? (allOptions.find(
        (o) => o.messageContent === value.messageContent && o.messageValue === value.messageValue,
      ) ?? value)
    : null;
  const selectValue = selected ? optionKey(selected) : undefined;

  return (
    <Select
      showSearch
      allowClear={allowClear}
      style={{ width: "100%" }}
      placeholder={placeholder ?? "Select LN2 message"}
      optionFilterProp="label"
      value={selectValue}
      onChange={(key: string | undefined) => {
        if (!key) {
          onChange(null);
          return;
        }
        const opt = allOptions.find((o) => optionKey(o) === key);
        if (opt) onChange(opt);
      }}
      disabled={disabled}
    >
      {groupedOptions.map((group) => (
        <Select.OptGroup key={group.label} label={group.label}>
          {group.options.map((opt) => (
            <Select.Option key={optionKey(opt)} value={optionKey(opt)} label={opt.label}>
              {opt.label}
            </Select.Option>
          ))}
        </Select.OptGroup>
      ))}
    </Select>
  );
}
